/*
 *  View for displaying a selectable tree hierarchy
 */
define([
  "jquery",
  "marionette",
  "messaging/messenger",
  "modules/shared/treeList/template/treeListTemplate.html",
], function ($, Marionette, Messenger, TreeListTemplate) {
  "use strict";

  const TreeListView = {};

  TreeListView.treeListView = Marionette.CompositeView.extend({
    tagName: "ul",
    className: "tree-list",
    template: TreeListTemplate,
    initialize: function (options) {
      this.collection = this.model.nodes;
      if (options && options.namespace) {
        this.namespace = options.namespace;
      }
    },
    itemViewOptions: function () {
      return {
        namespace: this.namespace,
      };
    },
    appendHtml: function (collectionView, itemView) {
      collectionView.$("li:first").append(itemView.el);
    },
    events: {
      "click .expand": "expand",
      "click .hide": "collapse",
      "change .tree-node-select": "handleSelection",
    },
    onRender: function () {
      this.toggleView();
    },
    toggleView: function () {
      //set the expanded icon to the root nodes
      if (this.collection) {
        this.expanded = true;
        this._toggleHide(this.model.get("data"));
      }
    },
    expand: function () {
      if (!this.expanded) {
        this.expanded = true;
        this.$el.find("ul").show();
        this._toggleHide(this.model.get("data"));
      }
    },
    collapse: function () {
      if (this.expanded) {
        this.expanded = false;
        this.$el.find("ul").hide();
        this._toggleExpand(this.model.get("data"));
      }
    },
    handleSelection: function (event) {
      //needed to stop the event from bubbling up to the parent
      event.stopPropagation();
      const isChecked = event.target.checked;
      let affectedNodeIds = []; // store all leaf node ids to trigger events for

      if (this.collection) {
        //parent selected, so select/de-select all the children as well
        this._updateChildren(this.collection, isChecked);

        // also collect all leaf node ids under this parent
        affectedNodeIds = this._getLeafNodeIds(this.model.nodes);
      } else {
        //child selected, check the other siblings as well
        //if all are selected/de-selected, then do the same to the parent
        const siblings = this.$el.parent().children().find("input");
        //the siblings() function doesn't select the correct tags due to how the model nest <ul>'s in the tree
        //so instead we'll chain the parent() and children() functions

        // always add this leaf node's id
        const nodeId = this.$el.find("input").data("node-id");
        affectedNodeIds.push(nodeId);

        if (siblings.length > 0) {
          //check if other siblings are selected
          let siblingCheckCount = 0;
          for (let i = 0; i < siblings.length; i++) {
            //go through list of siblings and count all the ones that are selected/de-selected
            if (siblings[i].checked === isChecked) {
              siblingCheckCount++;
            }
          }
          if (siblingCheckCount === siblings.length) {
            //all siblings are selected/de-selected
            this.$el.parent().children("input").prop("checked", isChecked);
          } else {
            //the siblings are currently a mixed list of checked and un-checked boxes
            //so make sure the parent is de-selected during this state
            this.$el.parent().children("input").prop("checked", false);
          }
        } else {
          //no other siblings, so go ahead and select the parent
          this.$el.parent().children("input").prop("checked", isChecked);
        }
      }
      // Trigger events for all affected leaf nodes
      affectedNodeIds.forEach((id) => {
        Messenger.vent.trigger(this.namespace + ":treeList:node:checked", id, isChecked);
      });
    },
    _getLeafNodeIds: function (collection) {
      let ids = [];
      collection.forEach(function (childModel) {
        if (childModel.nodes && childModel.nodes.length) {
          ids = ids.concat(this._getLeafNodeIds(childModel.nodes));
        } else {
          ids.push(childModel.get("data"));
        }
      }, this);

      return ids;
    },
    _toggleExpand: function (data) {
      this.$el
        .find("span[data-node-id='" + data + "']")
        .html('<i class="icon-plus-sign expand"></i>');
    },
    _toggleHide: function (data) {
      this.$el
        .find("span[data-node-id='" + data + "']")
        .html('<i class="icon-minus-sign hide"></i>');
    },
    _updateChildren: function (collection, isChecked) {
      collection.each(function (model) {
        this.$el.find("input[data-node-id='" + model.get("data") + "']").prop("checked", isChecked);

        //also select/de-select the grandchildren (and other descendents)
        if (model.nodes) {
          this._updateChildren(model.nodes, isChecked);
        }
      }, this);
    },
  });

  TreeListView.treeListRoot = Marionette.CollectionView.extend({
    itemView: TreeListView.treeListView,
    initialize: function (options) {
      this.namespace = options.namespace;
    },
    itemViewOptions: function () {
      return {
        namespace: this.namespace,
      };
    },
    getSelectedNodes: function () {
      const selectedNodes = [];
      const selectedList = this.$el.find(".tree-node-select:checked");
      selectedList.each(function () {
        selectedNodes.push($(this).data("node-id"));
      });
      return selectedNodes;
    },
    selectAll: function () {
      this.$el.find("input").prop("checked", true);
    },
    deselectAll: function () {
      this.$el.find("input").prop("checked", false);
    },
    getChecked: function (nodeId) {
      return this.$el.find("input[data-node-id=" + nodeId + "]").prop("checked");
    },
    setChecked: function (nodeId, isChecked) {
      this.$el.find("input[data-node-id=" + nodeId + "]").prop("checked", isChecked);
    },
  });

  return TreeListView;
});
